import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationService } from '../services/api';

// Query keys
export const notificationKeys = {
  all: ['notifications'],
  list: (page) => [...notificationKeys.all, 'list', page],
  unreadCount: () => [...notificationKeys.all, 'unread-count'],
};

// Hook for fetching notifications with infinite scroll
export const useNotifications = () => {
  return useInfiniteQuery({
    queryKey: notificationKeys.list(),
    queryFn: async ({ pageParam = 1 }) => {
      const response = await notificationService.getNotifications(pageParam, 20);
      return {
        notifications: response.data.notifications || [],
        nextPage: pageParam + 1,
        hasMore: response.data.hasMore !== false && response.data.notifications?.length === 20,
      };
    },
    getNextPageParam: (lastPage) => lastPage.hasMore ? lastPage.nextPage : undefined,
    staleTime: 2 * 60 * 1000, // 2 minutes
    onSuccess: () => {
      // Reset unread notifications count when fetching
      localStorage.setItem("unreadNotifications", 0);
    },
  });
};

// Hook for marking a notification as read
export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: notificationService.markAsRead,
    onSuccess: () => {
      // Invalidate notifications to update read status
      queryClient.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
};

// Hook for marking all notifications as read
export const useMarkAllNotificationsAsRead = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: notificationService.markAllAsRead,
    onSuccess: (data) => {
      console.log("Mark all as read successful:", data);
      
      // Invalidate notifications to update read status
      queryClient.invalidateQueries({ queryKey: notificationKeys.all });
      
      // Update localStorage
      localStorage.setItem("unreadNotifications", 0);
      
      // Dispatch custom event to update notification section and aside
      window.dispatchEvent(new CustomEvent('unreadCountUpdate', {
        detail: { unreadNotifications: 0 }
      }));
      
      console.log("Dispatched unreadCountUpdate event with count: 0");
    },
    onError: (error) => {
      console.error("Failed to mark all notifications as read:", error);
    }
  });
}; 